import React from 'react';
import { Link } from 'react-router-dom';

import { useAppContext } from '@prisjakt/ui-app-context';
import Button from '@prisjakt/ui-button';
import * as ButtonTypes from '@prisjakt/ui-button/src/types';

import CompareIcon from 'mdi-react/ScaleBalanceIcon';

type Props = {
  className?: string;
  products: Array<{ id: number }>;
  buttonText?: string;
  buttonProps?: ButtonProps;
};

type ButtonProps = {
  color?: ButtonTypes.Color;
  iconPosition?: ButtonTypes.IconPosition;
  size?: ButtonTypes.Size;
  variant?: ButtonTypes.Variant;
  onClick?: () => void;
};

const CompareButton = ({
  className,
  products,
  buttonText,
  buttonProps,
}: Props) => {
  const { linkTo } = useAppContext();
  const compareUrl = linkTo('productCompare', {
    products,
  });

  const defaultButtonProps: ButtonProps = {
    color: 'primary',
    variant: buttonText ? 'outlined' : 'icon',
  };

  return (
    <Button
      className={className}
      icon={<CompareIcon />}
      component={<Link to={compareUrl} />}
      {...defaultButtonProps}
      {...buttonProps}
    >
      {buttonText && buttonText}
    </Button>
  );
};

export default CompareButton;
